import { Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { filter } from "rxjs";
import { CoreComponent } from "./core/core.component";
import { environment } from "./environments/environment";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-root",
  imports: [RouterModule, CoreComponent, TranslateModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  private router = inject(Router);
   private readonly cookieService = inject(CookieService);

  constructor() {
    if (!environment.production) {
      this.cookieService.set("MA_SSO_SESS", environment.sessionid, undefined, "/");
      this.router.events
        .pipe(
          takeUntilDestroyed(),
          filter((event) => event instanceof NavigationEnd),
        )
        .subscribe((event) => {
          console.info(event);
        });
    }
  }
}
